import React from 'react';
import { AnnouncementContainer, AnnouncementInner } from './styles/announcement.styled';
export const Announcement = ({ icon, children, dataTest = 'announcement' }) => (React.createElement(AnnouncementContainer, { className: "PONCHO-announcement", "data-test": `${dataTest}-container` },
    React.createElement(AnnouncementInner, { className: "PONCHO-announcement__inner" },
        icon,
        React.createElement("div", { "data-test": `${dataTest}-children` }, children))));
//# sourceMappingURL=Announcement.js.map